<template>
  <v-container fluid
               class="pa-0 white dmbheader">
    <v-row justify="space-around"
           align="center"
           no-gutters
           class="header-inner">
      <v-row justify="space-around"
             align="center"
             no-gutters
             class="flex-nowrap">
        <v-col cols="4"
               left>
          <router-link to="/start"
                       tag="a"
                       title="Zur DMB-Rechtsschutz Maklerportal Startseite">
            <img height="72"
                 src="@/assets/svg/Logo_DMB-RS_Claim.svg"
                 alt="DMB Rechtsschutz">
          </router-link>
        </v-col>

        <template v-if="size==='normal'">
          <v-col cols="4"
                 class="ma-0 py-0 px-2">
            <a :href="'tel:' + maklerService.phoneClickable" class="black87">
              <div class="contact">
                <div class="iconContact">
                  <img class="iconContact"
                       src="@/assets/svg/ic_telefon.svg"
                       alt="Kontakt Telefon">
                </div>
                <div>
                  <span class="service-text">{{ maklerService.phone }}</span> <br>
                  <span class="subtext">Makler-Hotline</span>
                </div>

              </div>
            </a>
          </v-col>

          <v-col cols="4"
                 class="ma-0 py-0 px-2">
            <a href="mailto:maklerservice@dmb-rechtsschutz.de" class="black87">
              <div class="contact">
                <div class="iconContact">
                  <img class="iconContact"
                       src="@/assets/svg/ic_mail.svg"
                       alt="Kontakt EMail">
                </div>
                <div>
                  <span class="service-text">maklerservice@dmb-rechtsschutz.de</span> <br>
                  <span class="subtext">Maklerservice</span>
                </div>
              </div>
            </a>
          </v-col>
        </template>

        <template v-else-if="size==='small'">
          <v-col cols="2"
                 class="ma-0 py-0 px-2" />
          <div class="ma-0 py-0 px-2">
            <div class="contact-xs">
              <div class="subtext">
                <a :href="'tel:' + maklerService.phoneClickable">{{ maklerService.phone }}</a>
              </div>
              <div class="subtext">Makler-Hotline</div>
              <div class="subtext">
                <a href="mailto:maklerservice@dmb-rechtsschutz.de">maklerservice@dmb-rechtsschutz.de</a></div>
              <div class="subtext">Maklerservice</div>
            </div>
          </div>
        </template>

        <v-spacer v-else
                  cols="8" />
      </v-row>

      <div v-if="!$store.getters.isAuthenticated"
           class="pl-10">
        <v-btn color="primary"
               @click="$router.push('login')">
          Makler-Login
        </v-btn>
      </div>

    </v-row>
    <v-divider />
  </v-container>
</template>
<script>
export default {
  data: function () {
    return {
      contactDialog: false
    };
  },
  computed: {
    size() {
      return this.$vuetify.breakpoint.width > 949 || this.$vuetify.breakpoint.width > 899 && this.$store.getters.isAuthenticated ? 'normal' :
        this.$vuetify.breakpoint.width > 799 || this.$vuetify.breakpoint.width > 649 && this.$store.getters.isAuthenticated ? 'small' :
          null;
    },
    maklerService() {
      return this.$store.state.staticPagesContent.AboutUnternehmenMaklerBox;
    }
  }
};
</script>
<style>
.dmbheader .subtext {
  color: rgba(0, 0, 0, .38);
}

.dmbheader .service-text {
  font-size: 12pt;
}

.dmbheader .header-inner {
  height: 88px;
  max-width: 1280px!important;
  margin: auto;
  padding: 0 48px;
}

.dmbheader .contact {
  display: flex;
  justify-content: flex-end;
}

.dmbheader .contact .icon {
  margin-right: 20px;
}

.dmbheader .iconContact {
  margin: auto 8px auto auto;
  height: 40px;
}

.dmbheader .contact-xs {
  display: flex;
  justify-content: flex-end;
}

.dmbheader .contact-xs .subtext {
  white-space: nowrap;
  overflow: visible;
}

.dmbheader .contact-xs .subtext:nth-child(odd) {
  font-weight: 500;
  color: rgba(0, 0, 0, .87);
}

</style>

